import React from "react";
import PropTypes from "prop-types";
import AuthService from "../../service/AuthService";
const { LinearProgress, Divider,
  Typography, Box, FormControlLabel, FormControl, InputLabel, Select, MenuItem,
  FormGroup, Switch,
  Icon, } = require("@mui/material")
const { commons, util } = require("../../commons")
const { SnackBarWidget } = require("../../Widget");


class Project extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      message: "",
      apiService: false,
      projectId: "",
      projects: [],
      projectError: false
    };
  }

  componentDidMount() {
    this.getProjects();
  }

  handleSwitchChange = (event) => {
    this.setState({ viewType: event.target.checked });
  };


  getProjects = () => {
    let params = { "op": "getProject" };

    if (AuthService.getUserInfo().role != "admin")
      params.users = [AuthService.getUserInfo()._id]
    commons.getAPIRes(params, "POST", "project")
      .then(res => {
        if (res.status) {
          const transformedData = res.result.map(item => ({ ...item, _id: item._id.$oid }));
          this.setState({ projects: transformedData, projectId: transformedData[0]._id })
          if (localStorage.getItem("projectId") == null) {
            localStorage.setItem("projectId", transformedData[0]._id)
            localStorage.setItem("projectName", transformedData[0].name)
          }
          else {
            this.setState({ projectId: localStorage.getItem("projectId") })
          }

        }
        else {
          alert("Projects not assigned to continue with login! Please contact manager/administrator")
          localStorage.clear()
          window.location.href = '/login';
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }


  loadDefaults = () => {
    this.setState({ status: false, message: "" })
  }
  handleProject = (e) => {

    let { projects } = this.state;
    this.setState({ projectId: e.target.value.toString() })
    localStorage.setItem("projectId", e.target.value.toString())
    let projectExists = projects.find(item => item._id === e.target.value);
    if (projectExists) {
      localStorage.setItem("projectName", projectExists.name)

    }


  }


  render() {
    const { status, message, apiService,
      projectId, projects, projectError, viewType, fileList } = this.state;

    return (
      <Box sx={{ alignContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

          <FormControl variant="outlined"
            disabled={this.props.disabled}
            style={{ margin: 1, padding: 2, width: 300 }}
            error={projectError}>
            <InputLabel id="demo-simple-select-label">Project</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={projectId}
              label="Project"
              onChange={(e) => this.handleProject(e)}
            >
              {projects.map(item =>
                <MenuItem value={item._id.toString()} key={item._id.toString()}>{item.name}</MenuItem>
              )}

            </Select>
          </FormControl>
        </div>
       
        {apiService ? <LinearProgress /> : false}
        <SnackBarWidget message={message} status={status} />
      </Box>
    );
  }
}

Project.propTypes = {
  id: PropTypes.string,
  cancelDialog: PropTypes.func,
  reloadPage: PropTypes.func,
  action: PropTypes.string
};
export default Project;
